module.exports = __webpack_public_path__ + "static/img/kb-card-thumb.69d5353.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/kb-card-thumb.jpg
// module id = bMqF
// module chunks = 0